import { Parking } from "../enums/Parking";
import { getRightYear } from "./DateHelpers";
import { getMonthNumber, getMonthString } from "./Statics";

export function extractDetailsFromIdNumber(idNumber: string) {
  const dob = idNumber.slice(0, 6);
  const gender = Number(idNumber.charAt(6));

  if (idNumber?.length > 5) {
    const day = dob.slice(4, 6);
    const month = dob.slice(2, 4);
    const year = dob.slice(0, 2);

    if (idNumber?.length <= 6) {
      if (Number(day) < 31 || Number(getMonthNumber(month)) < 12)
        return {
          day: day,
          month: getMonthString(month),
          year: getRightYear(year),
          gender: "",
        };
    }
    if (idNumber?.length > 6) {
      let actualGender: string = "";

      if (gender >= 0 && gender <= 4) {
        actualGender = "FEMALE";
      }
      if (gender >= 5 && gender <= 9) {
        actualGender = "MALE";
      }

      return {
        day: day,
        month: getMonthString(month),
        year: getRightYear(year),
        gender: actualGender,
      };
    }
  } else {
    return { day: "", month: "", year: "", gender: "" };
  }
}

export function isIdNumberValid(code: string): boolean {
  if (Number.isNaN(code)) return false;
  var len = code?.length;
  var parity = len % 2;
  var sum = 0;
  for (var i = len - 1; i >= 0; i--) {
    var d = parseInt(code.charAt(i));
    if (i % 2 === parity) {
      d *= 2;
    }
    if (d > 9) {
      d -= 9;
    }
    sum += d;
  }
  return sum % 10 === 0;
}

export function isEmpty(value: any) {
  return (
    value == null || (typeof value === "string" && value.trim().length === 0)
  );
}

export function isRoaming(parkingLocation: string) {
  return parkingLocation === Parking.ROAMING;
}
